<div class="odata-main-container" [class.closed]="!showPanel" #filterComponent>
  <div
    class="filter-button-container"
    [fxLayoutAlign]="smallSize ? 'start' : 'start center'"
    fxLayoutGap="8px"
    [fxLayout]="smallSize ? 'column' : 'row'"
  >
    <div fxLayoutAlign="start center">
      <lineup-views-menu
        fxFlex
        [title]="filterMenuOption.viewMenuTitle"
        [editable]="!filterMenuOption.readOnlyViewMenu"
        [hideSearch]="filterMenuOption.hideViewMenuSearchBar"
        [selectedView]="selectedView"
        [viewContextId]="filterMenuOption.viewContextId"
        (selectChanged)="onSelectView($event)"
        (create)="onCreateView()"
        (edit)="onEditView($event)"
        (reset)="onSelectView($event)"
      >
      </lineup-views-menu>
      <div *ngIf="smallSize">
        <button
          style="margin-left: 8px"
          *ngIf="!filterMenuOption.readOnlyViewMenu && selectedView?.isModified && canSaveChanges"
          class="filter-button"
          mat-stroked-button
          aria-label="Save View"
          (click)="onSaveViewChange()"
        >
          <mat-icon>save</mat-icon>
        </button>
      </div>
    </div>
    <div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
      <button data-testid="odata-filter-button" class="filter-button" mat-stroked-button (click)="onOpen()">
        <mat-icon [color]="showFieldDeletedWarning ? 'warn' : ''">{{
          showFieldDeletedWarning ? 'error' : 'filter_list'
        }}</mat-icon>
        <span class="button-text">
          <span>{{ appliedFilters?.length != 0 ? ' ' + appliedFilters?.length : '' }} </span>
          <span [fxHide]="midSize">{{ filterButtonText }}</span>
        </span>
      </button>
      <div fxFlex *ngIf="!filterMenuOption.hideSearchBar">
        <search-bar
          [searchText]="searchText"
          [placeholder]="filterMenuOption.searchPlaceHolder ?? ''"
          (onChange)="search($event)"
          fxFlex="100%"
        ></search-bar>
      </div>
      <mat-button-toggle-group
        [(ngModel)]="customViewDisplayLayout"
        class="layout-toggle-group"
        *ngIf="showDisplayLayoutOptions"
        (ngModelChange)="displayLayoutChanged.emit($event)"
      >
        <mat-button-toggle
          *ngIf="filterMenuOption.showListToggleButton"
          [value]="customViewDisplayLayoutEnum.List"
          aria-label="List"
        >
          <mat-icon>view_list</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          *ngIf="filterMenuOption.showTableToggleButton"
          [value]="customViewDisplayLayoutEnum.Table"
          aria-label="Table"
        >
          <mat-icon>grid_on</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle
          *ngIf="filterMenuOption.showChartToggleButton"
          [value]="customViewDisplayLayoutEnum.Chart"
          aria-label="Chart"
        >
          <mat-icon>bar_chart</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
      <button
        class="columns-button"
        mat-stroked-button
        (click)="manageColumns.emit()"
        *ngIf="!filterMenuOption.hideManageColumns"
        aria-label="Manage columns"
      >
        <mat-icon>view_week</mat-icon>
        <mat-icon class="lock-icon" *ngIf="!doesPlanAllowManageColumns">lock</mat-icon>
      </button>
    </div>
    <div *ngIf="!smallSize">
      <button
        *ngIf="!filterMenuOption.readOnlyViewMenu && selectedView?.isModified && canSaveChanges"
        class="filter-button"
        mat-stroked-button
        aria-label="Save View"
        (click)="onSaveViewChange()"
      >
        <mat-icon>save</mat-icon>
        <span [fxHide]="midSize"> Save View</span>
      </button>
    </div>
  </div>
  <div [class.filter-panel-open]="showPanel" class="filter-panel">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="filter-panel-title">
      <h4>
        {{ name }} Filters
        <button class="clear-button" mat-button *ngIf="appliedFilters.length > 0" (click)="clearAndApply()">
          CLEAR ALL
        </button>
      </h4>
      <p>Results must match <b>all</b> of the following rules</p>
    </div>
    <div class="filter-panel-content">
      <p *ngIf="selectedFilters.length == 0">No filters applied. Results showing all teams.</p>

      <div
        *ngFor="let selectedFilter of selectedFilters; let i = index"
        class="filters"
        [class.sub-filters-added]="selectedFilter.isSubFilterAdded"
      >
        <odata-filter-item
          [selectedFilter]="selectedFilter"
          [filters]="filters"
          (delete)="deleteFilter(i)"
          (addSubFilter)="addSubFilter(selectedFilter)"
        >
        </odata-filter-item>
        <div *ngIf="selectedFilter.isSubFilterAdded" class="sub-filters">
          <p class="sub-filters-title">Conditions</p>
          <div *ngFor="let selectedSubFilter of selectedFilter.selectedSubFilters; let i = index" class="filters">
            <odata-filter-item
              [selectedFilter]="selectedSubFilter"
              [filters]="selectedFilter.filter.subFilter.filters"
              (delete)="deleteSubFilter(selectedFilter, i)"
            >
            </odata-filter-item>
          </div>
          <button class="add-filter-button" mat-button color="primary" (click)="addSubFilter(selectedFilter)">
            + ADD ANOTHER CONDITION
          </button>
        </div>
      </div>

      <button class="add-filter-button" mat-button color="primary" (click)="addFilter()">+ ADD FILTER</button>
    </div>
    <div class="filter-panel-action-buttons" style="position: relative">
      <p *ngIf="!isValid && isApplied" class="error-message">
        Please make sure to select all values, or remove the filter before applying.
      </p>
      <button class="apply-filter" mat-raised-button color="primary" (click)="onApply()">APPLY FILTERS</button>
      <button class="cancel-button" mat-button (click)="onCancel()">CANCEL</button>
      <button
        type="button"
        mat-icon-button
        color="primary"
        class="copy-button"
        (click)="onCopyODataFilter()"
        matTooltip="Copy search query to your clipboard"
        aria-label="Copy search query to your clipboard"
        style="position: absolute; right: 0px"
      >
        <mat-icon>integration_instructions</mat-icon>
      </button>
    </div>
  </div>
</div>
